import InventoZen from "@/components/icons/InventoZen.tsx";
import { Button } from "@/components/ui/button.tsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Confirmation = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const goToLogin = async () => {
    navigate("/");
  };

  return (
    <div className="h-full flex items-center justify-center">
      <div className="m-auto w-[500px] h-fit p-10 bg-white rounded-lg shadow border border-slate-200 flex-col justify-start items-center gap-8 inline-flex">
        <div>
          <div className="justify-center items-center flex">
            <InventoZen />
          </div>
          <p className="text-center text-slate-900 text-3xl font-semibold font-['Instrument Sans'] leading-loose">
            {t("passwordReset")}
          </p>
          <p className="text-center text-[#475467] text-base font-['Instrument Sans']">
            {t("yourPasswordHasBeenResetSuccessfully")}
          </p>
        </div>
        <div className="w-full">
          <Button
            type="submit"
            variant="ghost"
            onClick={goToLogin}
            className="mt-8 h-12 px-4 py-3 bg-[#008bd4] rounded-lg border border-[#006eab] justify-center items-center gap-1.5 inline-flex"
          >
            <div className="px-0.5 justify-center items-center flex">
              <p className="text-white text-base font-semibold font-['Raleway'] leading-normal">
                {t("continue")}
              </p>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
